// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3klkR","insightsList":"newBusinessInsightsMenu_insightsList__VDgkQ","active":"newBusinessInsightsMenu_active__131uG"};